export default __webpack_public_path__ + "static/media/icon-patient.e0478f14.svg";